var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _circle, _circle2, _circle3, _path7, _path8, _circle4, _circle5, _circle6, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8DisplayMonitorExternal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M596.814 395.81C596.917 391.467 600.468 388 604.812 388H790.188C794.532 388 798.083 391.467 798.186 395.81L800.805 505.81C800.912 510.301 797.3 514 792.807 514H602.193C597.7 514 594.088 510.301 594.195 505.81L596.814 395.81Z",
    fill: "#313345"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M597.814 395.833C597.904 392.033 601.011 389 604.812 389H790.188C793.989 389 797.096 392.033 797.186 395.833L799.805 505.833C799.899 509.763 796.738 513 792.807 513H602.193C598.262 513 595.101 509.763 595.195 505.833L597.814 395.833Z",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M606 502L608.45 405.949C608.478 404.865 609.365 404 610.45 404H783.55C784.635 404 785.522 404.865 785.55 405.949L788 502H606Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M731 430V416H783L783.5 430H731Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 420,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#DADADA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 735,
    y: 424,
    width: 13,
    height: 2,
    rx: 1,
    fill: "#DADADA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 750,
    y: 424,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#DADADA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 759,
    y: 424,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#DADADA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M731 447V433H783L783.5 447H731Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M608.391 410L608.464 405.964C608.484 404.873 609.374 404 610.464 404H783.57C784.647 404 785.53 404.853 785.568 405.929L785.713 410H608.391Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 619,
    cy: 407,
    r: 1,
    fill: "#8BEF75"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 616,
    cy: 407,
    r: 1,
    fill: "#FFD27A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 613,
    cy: 407,
    r: 1,
    fill: "#FF7171"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M603 398L603 396C603 394.895 603.896 394 605 394H789.53C790.623 394 791.514 394.877 791.53 395.97L791.561 398H603Z",
    fill: "#E2E8ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M800.357 487L800.805 505.81C800.912 510.301 797.3 514 792.807 514H602.193C597.7 514 594.088 510.301 594.195 505.81L594.643 487",
    stroke: "#2B2D43"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 613,
    cy: 396,
    r: 1,
    fill: "#716E95"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 396,
    r: 1,
    fill: "#716E95"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 607,
    cy: 396,
    r: 1,
    fill: "#716E95"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M617.963 416.962C617.984 416.425 618.425 416 618.963 416H727.013C727.56 416 728.006 416.44 728.012 416.987L728.987 493.987C728.994 494.545 728.544 495 727.987 495H616.039C615.472 495 615.018 494.529 615.039 493.962L617.963 416.962Z",
    fill: "#00A3C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M669.201 517.759C669.687 516.688 670.755 516 671.932 516H723.068C724.245 516 725.313 516.688 725.799 517.759L732.429 532.345C733.633 534.993 731.697 538 728.788 538H666.212C663.303 538 661.367 534.993 662.571 532.345L669.201 517.759Z",
    fill: "url(#paint0_linear_1989_6394)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M690 514H704V525C698.894 526.816 695.849 526.79 690 525V514Z",
    fill: "url(#paint1_linear_1989_6394)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M665.5 536.5H729",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M633 452L618 473.5H727V427L698.5 459L673 437.5L646.5 459L633 452Z",
    fill: "url(#paint2_linear_1989_6394)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1989_6394",
    x1: 697.5,
    y1: 516,
    x2: 697.5,
    y2: 538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1989_6394",
    x1: 690,
    y1: 516,
    x2: 705.5,
    y2: 516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526096,
    stopColor: "#575A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323448"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1989_6394",
    x1: 672.5,
    y1: 427,
    x2: 672.5,
    y2: 473.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#577C85",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8DisplayMonitorExternal);
export default __webpack_public_path__ + "static/media/8DisplayMonitorExternal.af677dbc1bc3572e05210f522e5d3aef.svg";
export { ForwardRef as ReactComponent };